module.exports = __webpack_public_path__ + "img/ep7-5a.679c6d75.png";